@if (isUpdating$ | async) {
  <cx-spinner class="overlay"> </cx-spinner>
}

@if (token$ | async; as token) {
  <form (ngSubmit)="onSubmit(token)" [formGroup]="form">
    <label class="label-password">
      <span class="label-content reset-password-label">{{
        'register.newPasswordReset' | cxTranslate
      }}</span>
      <div class="label-input">
        <input class="form-control" [type]="showPassword ? 'text' : 'password'"
          placeholder="{{ 'register.password.placeholder' | cxTranslate }}" formControlName="password" />
        <app-custom-icons (click)="isPasswordHidden()"
        [type]="showPassword ? iconTypes.EYE : iconTypes.EYE_SLASH"></app-custom-icons>
      </div>
      <cx-form-errors [control]="form.get('password')"></cx-form-errors>
    </label>
    <label class="label-password">
      <span class="label-content confirm-reset-password-label">{{
        'register.newPasswordConfirm' | cxTranslate
      }}</span>
      <div class="label-input">
        <input class="form-control" [type]="showPasswordConfirm ? 'text' : 'password'"
          placeholder="{{ 'register.confirmPassword.placeholder' | cxTranslate }}" formControlName="passwordConfirm" />
        <app-custom-icons (click)="isPasswordHiddenConfirm()"
        [type]="showPasswordConfirm ? iconTypes.EYE : iconTypes.EYE_SLASH"></app-custom-icons>
      </div>
      <cx-form-errors [control]="form.get('passwordConfirm')"></cx-form-errors>
    </label>
    <button class="btn btn-block btn-primary" [disabled]="form.disabled">
      {{ 'register.resetPassword' | cxTranslate }}
    </button>
  </form>
}